export const environment = {
    production: true,
    apiUrl: "https://forddiag-api.helm.com",
    legacyUrl: "https://www2.helminc.com/ngsm"
};